import { Reducer } from "redux";
import ContractingState from "./ContractingState";
import {
  ContractingAction,
  ContractingActionTypes,
} from "./ContractingActions";
import { produce } from "immer";

const initialState: ContractingState = {
  progress: {
    steps: {}
  },
  configuration: {}
};

export const ContractingReducer: Reducer<
  ContractingState,
  ContractingAction
> = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case ContractingActionTypes.SET_CONTRACTING_PROGRESS:
        draft.progress = action.data;
        break;
      case ContractingActionTypes.SET_ALL_CONTRACTING_STEPS:
        draft.progress.steps = action.data;
        break;
      case ContractingActionTypes.SET_CONTRACTING_STEP:
        draft.progress.steps[action.data.key] = action.data.value;
        break;
      case ContractingActionTypes.SET_CONTRACTING_STEP_TOUCHED:
        const stepTouched = draft.progress.steps[action.data.key];  
        if (stepTouched) {
          stepTouched.touched = action.data.value.touched;
          // seta actual step route
          draft.progress.actualStepRoute = action.data.value.stepRoute;          
        }
        break;
      case ContractingActionTypes.SET_CONTRACTING_STEP_VALID:
        const stepValid = draft.progress.steps[action.data.key];  
        if (stepValid) {
          stepValid.valid = action.data.value;          
        }
        break;
      case ContractingActionTypes.SET_CONTRACTING_STEP_DISABLED:
        const stepDisabled = draft.progress.steps[action.data.key];  
        if (stepDisabled) {
          stepDisabled.disabled = action.data.value;          
        }
        break;
      case ContractingActionTypes.SET_CONTRACTING_STEP_VALUES:
        const stepValues = draft.progress.steps[action.data.key];  
        if (stepValues) {
          stepValues.values = action.data.value;          
        }
        break;
      case ContractingActionTypes.SET_CONTRACTING_ID:
        draft.progress.contractingId = action.data;
        break;
      case ContractingActionTypes.SET_CONTRACTING_CONFIGURATION:
        draft.configuration = action.data;
        break;
      default:
        break;
    }
  });
